// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/Flyout.scss
// module id = 2208
// module chunks = 0